import Vue from "vue";
import Component from "./SelectMember.vue";

const Constructor = Vue.extend(Component);

// const instances = [];
let seed = 1;

const SelectMemberPicker = options => {
  if (Vue.prototype.$isServer) return;

  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new Constructor({
    propsData: {
      ...rest,
    },
    data: {
      //autoClose: autoClose === undefined ? 3000 : autoClose
    },
  });

  const id = `SelectMemberPicker_${seed++}`;
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  //绑定 change 方法
  instance.vm.$on("change", (selVal, selData) => {
    if (instance.change) {
      instance.change(selVal, selData);
    }
  });
  instance.vm.$on("clear", (selVal, selData) => {
    if (instance.change) {
      instance.clear(selVal, selData);
    }
  });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};

export default SelectMemberPicker;
